<template>
  <div class="newLogin">
    <template>
      <!-- 主要视图开始 -->
      <div class="content_login">
        <div class="left" />
        <div class="right">
          <h2>欢迎登录</h2>
          <p>WELCOME TO LOGIN</p>
          <div class="right_form">
              <el-form :model="form" ref="form" label-width="100px" class="password_login" :rules="rules">
                  <el-form-item prop="email">
                    <el-input v-model="form.email" @keydown.enter.native="verification('form')" placeholder="请输入邮箱或手机号">
                      <i slot="prefix" class="verify_i">
                        <img src="./assets/images/login_number.png"/>
                      </i>
                    </el-input>
                  </el-form-item>
                  <el-form-item prop="password">
                    <el-input v-model="form.password" @keydown.enter.native="verification('form')" type="password" class="input_bottom" placeholder="请输入密码">
                      <i slot="prefix" class="verify_i">
                        <img src="./assets/images/login_password.png" />
                      </i>
                    </el-input>
                  </el-form-item>
                   <el-form-item prop="validcode">
                      <el-input v-model="form.validcode" maxlength="4" @keydown.enter.native="verification('form')" placeholder="请输入验证码" style="width:150px;">
                        <i slot="prefix" class="verify_i">
                          <img src="./assets/images/login_Verification.png" />
                        </i>
                      </el-input>
                      <ValidCode @input="createValidCode"/>
                    </el-form-item>
                  <el-form-item class="login_button">
                    <el-button class="login_submit" type="primary" @click="verification('form')">验证</el-button>
                  </el-form-item>
              </el-form>
          </div>
          <div class="button_bottom">
               <p @click="goRegister()">注册</p>
               <p @click="goPassword()">忘记密码？</p>
          </div>
        </div>
      </div>
      <!-- 主要视图结束 -->
    </template>
  </div>
</template>

<script>
import md5 from "js-md5";
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("ws");
import { userLoginAjax} from "@/services/loginRegister";
import ValidCode from '@/components/ValidCode';
//输入框不为空
window.onkeypress = (event) => {
  if (event.keyCode == 32) event.returnValue = false
}
export default {
  name: "newLoginbackground",
  components: {ValidCode},
  data() {
    // 验证密码登录的邮箱地址或手机号input框
    let validateEmail = (rule, value, callback) => {
      let email = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      let phone = /^0{0,1}(13[0-9]|15[7-9]|153|156|18[7-9])[0-9]{8}$/;
          if (value === "") {
            return callback(new Error('请输入邮箱地址或手机号'));
          }
          else if(!email.test(value)&&!phone.test(value)) {
            return callback(new Error('请输入正确的邮箱地址或手机号'));
          }
          callback();
    };
    // 验证密码登录的密码input框
    let validatePass = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error('请输入密码'));
      }
      callback();
    };
    // 验证密码登录的验证码input框
    let validateCode = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error('请输入验证码'));
      }else if(value!==this.validCode){
        return callback(new Error('验证码错误'))
      }
      callback();
    };
    return {
      // 
      disabledPhone: false,
      // 
      verPhone: false,
      form: {
        email: "",
        password: "",
        validcode: ""
      },
      verificationCodePhone: '发送验证码',
      rules: {
        email: [{ required: true, validator: validateEmail, trigger: "blur" }],
        password: [{ required: true,validator: validatePass, trigger: "blur" }],
        validcode: [{ required: true, validator: validateCode, trigger: "blur" }]
      }
    };
  },
  mounted() {
  },
  methods: {
     //websocket
    ...mapActions(["UPDATE_LOGIN_INFO"]),
    // 密码登录验证码
    createValidCode (data) {
      this.validCode = data;
    },
    // 密码登录
    verification(form) {
      const self = this;
      self.$refs[form].validate(async valid => {
        if (valid) {
          let params = Object();
          Reflect.set(params, "loginName", self.form.email);
          Reflect.set(params, "password", md5(self.form.password));
          self.$message.closeAll();
          const resp = await userLoginAjax(params);
          if (resp.status === 200 && resp.success) {
            let result = resp.result;
            localStorage.setItem("userInfo", JSON.stringify(result));
            localStorage.setItem("myUser", JSON.stringify(result));
            self.setCompanyCode(result);
            self.UPDATE_LOGIN_INFO(result);
            self.$nextTick(() => {
              self.$router.push({ name: "homeMiddleware" }); // 跳到首页
            })
          }
        }
      });
    },
    // 储存平台编码
    setCompanyCode(userInfo) {
      let companyCode = localStorage.getItem('companyCode');
      let hasCompany = false;
      if (companyCode && companyCode !== 'null') {
        userInfo.companyList.forEach(company => {
          if (company.code === companyCode) {
            hasCompany = true;
          }
        })
      }
      if (!companyCode || companyCode === 'null' || !hasCompany) {
        if (userInfo.lastSelectCompany) {
          companyCode = userInfo.lastSelectCompany.code;
        } else if (userInfo.majorCompanyCode) {
          companyCode = userInfo.majorCompanyCode;
        } else if (userInfo.seltCompany) {
          companyCode = userInfo.seltCompany.code;
        } else if (userInfo.companyList && userInfo.companyList.length) {
          companyCode = userInfo.companyList[0].code;
        }
      }
      if (companyCode) {
        localStorage.setItem("myCompanyCode", companyCode)
        localStorage.setItem("companyCode", companyCode)
      }
    },
    //跳转注册
    goRegister() {
      this.$router.push("/login/registration");
    },
    //跳转重置密码
    goPassword() {
      this.$router.push("/login/retrievePassword");
    }
  }
};
</script>
<style lang="less" scoped>
@import "./assets/style.less";
</style>